import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../../services/service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  user:any;
  keterangan:string;

  constructor(private service:ServiceService, private router:Router) {
    this.user = this.service.checkLogin();
    let extra = this.service.getExtra();
    let setting = this.service.getSetting();
    this.keterangan = setting.keterangan;
    let totalWaktu = (setting.lama_ujian * 60);
    if(extra.sisa_waktu < totalWaktu){
      this.router.navigate(['/soal']);
    }
  }

  ngOnInit() {
    
  }

  actionSoal(){
    this.router.navigate(['/soal']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts